import React, { useEffect, useMemo } from "react";
import { getComponentProps } from "./util";

declare const window: any;

const loadCSS = (filename: string) => {
  const stylesheet = document.createElement("link");
  stylesheet.setAttribute("rel", "stylesheet");
  stylesheet.setAttribute("type", "text/css");
  stylesheet.setAttribute("href", filename);
  document.head.appendChild(stylesheet);
};

export const loadPlugins = async (pluginUrl: string, scriptId: string, loaderFn = () => { }) => {
  const res = await fetch(pluginUrl + '/asset-manifest.json');
  const { files } = await res.json();
  const script = document.createElement('script');
  script.id = scriptId;
  script.onload = loaderFn;

  const jsArtifact = '/static' + files['main.js'].split('static')[1]
  script.src = `${pluginUrl}${jsArtifact}`;

  if (files['main.css']) {
    const cssArtifact = '/static' + files['main.css'].split('static')[1]
    loadCSS(`${pluginUrl}${cssArtifact}`)
  }
  document.head.appendChild(script);
};

export default function MicroFrontend(props: any) {
  const { pluginName, type, widgetName } = props.json;
  const pluginId = props.id
  let identifier = pluginName || type;
  identifier = identifier === "Image" ? "ImageViewer" : identifier

  const pluginStyle = identifier === "ImageViewer" ? { height: "100%", width: "100%"} : {}

  const updatedProps = useMemo(() => {
    return {
      ...props,
      renderer: false,
      visibility: true,
    }
  }, [props]);

  // to allow config functions default values
  if(updatedProps?.json?.properties){
    updatedProps.json.properties={...updatedProps.json.properties,...getComponentProps(updatedProps)}
  }     
  
  useEffect(() => {
    if (window[identifier]) {
      const { type: pluginType, data: plugin } = window[identifier];
      
      if (pluginType === "Package") {
        plugin.widgets[widgetName].render(pluginId, updatedProps)
      } else if (pluginType === "Widget") {
        plugin.render(pluginId, updatedProps)
      }
    }
  }, [identifier, updatedProps, pluginId, widgetName]);

  return (
    <div className="plugin-wrapper" style={{ width: "100%", height: "100%" }}>
      <div style={pluginStyle} data-test-id={`plugin_id_${pluginId}`} id={pluginId} className={identifier}></div>
    </div>
  );
}
